export class TipoOsAtivoParamModel {
    descricao: String = '';
    codigoMicroarea: String;
    ativoId: number;
    paginaAtual: number;
}
